import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideSeoMetaTags } from './core/seo/initializer/provide-seo-metatags';
import { provideStoreUtmParams } from './core/utm/initializer/store-utm-params.initializer';
import { provideSentry } from './core/sentry/provide-sentry';
import { setBaseUrlInterceptor } from './core/base-url/interceptors/set-base-url.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(withFetch(), withInterceptors([setBaseUrlInterceptor])),
    provideSeoMetaTags(),
    provideStoreUtmParams(),
    !isDevMode() ? provideSentry() : [],
  ],
};
